import styled from 'styled-components';

export const StyledAnnouncementContainer = styled.div`
  display: flex;
  height: 45px;
  max-height: 45px;
  justify-content: center;
  background-color: ${({ theme }) => theme.color.bodyTextColor};
  color: ${({ theme }) => theme.color.secondaryForeground};
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 50;
`;

export const StyledAnnouncementContent = styled.nav`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  padding: 0 20px;
`;
